export enum DocumentsSearchType {
  CHANGELOG = 'CHANGELOG',
  SECTION_REFERENCES = 'SECTION_REFERENCES',
  GLOBAL_REFERENCE = 'GLOBAL_REFERENCE',
  CLAUSE_REFERENCES = 'CLAUSE_REFERENCE',
  SECTIONS = 'SECTIONS',
}
